import { Controller } from "@hotwired/stimulus"

// Simple in-page tabs.
// data-controller="tabs"
//   tab button: data-tabs-target="tab" data-tabs-name="js" data-action="tabs#select"
//   panel:      data-tabs-target="panel" data-tabs-name="js"
// The first tab is shown on connect.
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const first = this.tabTargets[0]?.dataset.tabsName
    if (first) this.show(first)
  }

  select(event) {
    this.show(event.currentTarget.dataset.tabsName)
  }

  show(name) {
    this.tabTargets.forEach((t) => t.classList.toggle("active", t.dataset.tabsName === name))
    this.panelTargets.forEach((p) => { p.hidden = p.dataset.tabsName !== name })
  }
}
